import InitRoot from "@/router/InitRoot";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";

import refundRoutes from "@/refund/routes";

import SettingsList from "@/pages/Settings/index";
import BalanceAndWithdraw from "@/pages/Sale/Withdraw/balanceAndWithdraw";
import ReportSale from "@/pages/Sale/Report/report";
import InvoiceList from "@/pages/Shop/Invoice/List";
import InvoiceCallback from "@/pages/Shop/Invoice/Callback";
import CustomerCreateBulk from "@/pages/Shop/Customer/CreateBulk/CreateBulk";
import InvoiceEditInvoice from "@/pages/Shop/Invoice/Edit";
import InvoiceCorrectInvoice from "@/pages/Shop/Invoice/Correction";
import IpgOauth from "@/pages/Connection/Oauth/OauthList";
import ProductCreateBulk from "@/pages/Shop/Product/CreateBulk/CreateBulk";
import InvoiceCreateInvoice from "@/pages/Shop/Invoice/Create";
import UserMessaging from "@/pages/Profile/messaging";
// import DisplaySettings from "@/pages/Profile/display";
import UserPersonal from "@/pages/Settings/Personal/PersonalEdit";
import UserBank from "@/pages/Settings/Bank/BankEdit";
import UserBusiness from "@/pages/Settings/Business/BusinessEdit";
import SettlementRecordList from "@/pages/Settlement/Report/ReportSettlementList/index";
import SettlementList from "@/pages/Settlement/Report/List";
import SettlementIDCreate from "@/pages/Settlement/ID/Create";
/* // TODO need prop

import IpgMessagingService from "@/pages/Connection/Services/details/Messaging";

*/

import Main from "@/pages";
import UserCheckPermission from "@/utils/UserCheckPermission";
import { RequireRole } from "@/router/RequireRole";
import { USER_CLAIMS_LIST } from "@/utils/useUserClaims";
import { DetectMobileView } from "@/router/DetectMobileView";
import MobileSettingsPersonalList from "@/mobile/Settings/Personal/index";
import MobileSettingsWrapper from "@/mobile/Settings/index";
import MobileSettingsMenu from "@/mobile/Settings/Menu/index";
import MobileEditName from "@/mobile/Settings/Personal/Edit/Name";
import MobileEditLastName from "@/mobile/Settings/Personal/Edit/LastName";
import MobileEditFatherName from "@/mobile/Settings/Personal/Edit/FatherName";
import MobileEditPhoneNumber from "@/mobile/Settings/Personal/Edit/PhoneNumber";
import MobileEditBirthDate from "@/mobile/Settings/Personal/Edit/BirthDate";
import MobileEditBirthCertificateNumber from "@/mobile/Settings/Personal/Edit/BirthCertificateNumber";
import MobileEditNationalCode from "@/mobile/Settings/Personal/Edit/NationalCode";
import MobileEditEmail from "@/mobile/Settings/Personal/Edit/Email";
import ProfilePhoto from "@/mobile/Settings/Personal/Edit/Documents";
import MobileBankList from "@/mobile/Settings/Bank";
import MobileEditShaba from "@/mobile/Settings/Bank/Edit/Shaba";
import BusinessName from "@/mobile/Settings/Business/Edit/BusinessName";
import BusinessDescription from "@/mobile/Settings/Business/Edit/BusinessDescription";
import BusinessState from "@/mobile/Settings/Business/Edit/BusinessState";
import BusinessCity from "@/mobile/Settings/Business/Edit/BusinessCity";
import BusinessAddress from "@/mobile/Settings/Business/Edit/BusinessAddress";
import BusinessPhone from "@/mobile/Settings/Business/Edit/BusinessPhone";
import BusinessPostalCode from "@/mobile/Settings/Business/Edit/BusinessPostalCode";
import BusinessWebsite from "@/mobile/Settings/Business/Edit/BusinessWebsite";
import BusinessTaxcode from "@/mobile/Settings/Business/Edit/BusinessTaxcode";
import OfficialSubmited from "@/mobile/Settings/Business/Edit/Official/OfficialSubmited";
import OfficialBusinessName from "@/mobile/Settings/Business/Edit/Official/OfficialBusinessName";
import OfficialBusinessRegistrationDate from "@/mobile/Settings/Business/Edit/Official/OfficialBusinessRegistrationDate";
import OfficialBusinessSabtNumber from "@/mobile/Settings/Business/Edit/Official/OfficialBusinessSabtNumber";
import OfficialBusinessNationalCode from "@/mobile/Settings/Business/Edit/Official/OfficialBusinessNationalCode";
import MobileEditOfficialBusinessEconomicCode from "@/mobile/Settings/Business/Edit/Official/OfficialBusinessEconomicCode";
import MobileBusinessList from "@/mobile/Settings/Business";
import MobileEditOfficialBusinessDocument from "@/mobile/Settings/Business/Edit/Official/OfficialBusinessDocument";
import MobileTerminalList from "@/mobile/Settings/Terminal";
import MobileProfileWrapper from "@/mobile/Profile";
import MobileProfileMenu from "@/mobile/Profile/Menu";
import MobileProfileSocial from "@/mobile/Profile/Social";
import MobileProfileClient from "@/mobile/Profile/Client";
import MobileProfileMessaging from "@/mobile/Profile/Messaging";
import MobileProfile2Fa from "@/mobile/Profile/2Fa";
// import MobileProfileDisplay from "@/mobile/Profile/Display";
import MobileProfileDetails from "@/mobile/Profile/Details";
import MobileProfilePassword from "@/mobile/Profile/Password";
import MobileEnableLogin2Fa from "@/mobile/Profile/2Fa/Login/MobileEnableLogin2Fa";
import OverviewPage from "@/pages/Overview";
import ConnectionsRoot from "@/pages/Connection/index";
import Developers from "@/pages/Connection/Developers";
import ConnectionsPluginsPage from "@/pages/Connection/Plugins";
import ConnectionsPluginsDetailsPage from "@/pages/Connection/Plugins/details";

import ChangeLog from "@/pages/ChangeLog";
import { permissionsList } from "@/router/types";
import MobileDisableLogin2Fa from "@/mobile/Profile/2Fa/Login/MobileDisableLogin2Fa";
import DigitalAccountHome from "@/pages/DigitalAccount/home";
import LoginEzPay from "@/pages/DigitalAccount/Khavarmianeh/EzPayIframe";
import OpeningGuid from "@/pages/DigitalAccount/Saman/openingGuid";
import GetInfo from "@/pages/DigitalAccount/Saman/getInfo";
import SuccesFul from "@/pages/DigitalAccount/Saman/succesFul";
import Fail from "@/pages/DigitalAccount/Saman/fail";
import GetAccessAccount from "@/pages/DigitalAccount/Saman/getAccessAccount";
import YourAccount from "@/pages/DigitalAccount/yourAccount";
import SamanCreate from "@/pages/DigitalAccount/Saman/Create";
import GetAccessHelp from "@/pages/DigitalAccount/Saman/getAccessHelp";
import TermsAndConditions from "@/pages/DigitalAccount/termsAndCondition";
import TokenList from "@/pages/Connection/Developers/Token/TokenList";
import TurnOver from "@/pages/DigitalAccount/Saman/turnOver";
import SettlementRoot from "@/pages/Settlement";
import BankFormGuide from "@/pages/DigitalAccount/Saman/BankFormGuide";
import MyShopRoot from "@/pages/Shop";
import MySaleRoot from "@/pages/Sale";
import BnplListPage from "@/pages/Shop/Bnpl/List";
import BnplFinancialCalender from "@/pages/Shop/Bnpl/FinancialCalender";
import AccountConnectionForm from "@/pages/DigitalAccount/Saman/accountConnectionForm";
import ShowAllRequestTransferList from "@/pages/DigitalAccount/Saman/ShowAllRequestTransferList";
import DigitalAccountRoot from "@/pages/DigitalAccount";
import BnplActivationPage from "@/pages/Shop/Bnpl/Activation";
import BnplManagePlanPage from "@/pages/Shop/Bnpl/Plans";
import BnplManagePlanList from "@/pages/Shop/Bnpl/Plans/PlanList";
import BnplPlansLayout from "@/pages/Shop/Bnpl/Plans/Layout";
import BnplManageCreditLayout from "@/pages/Shop/Bnpl/Manage-Credit/Layout";
import BnplManageCreditPage from "@/pages/Shop/Bnpl/Manage-Credit";
import { DashboardRoutes } from "./constant";
import CustomerCreate from "../pages/Shop/Customer/Create";

import Login from "../pages/Login";
import Logout from "../pages/Logout";
import OAuthCallback from "../pages/OAuthCallbackPage";

import CustomerEdit from "../pages/Shop/Customer/Edit";
import CustomerList from "../pages/Shop/Customer/List";

import ProductCreateCoupon from "../pages/Shop/Coupon/Create";
import ProductEditCoupon from "../pages/Shop/Coupon/Edit";
import ProductCouponList from "../pages/Shop/Coupon/List";
import ProductCreate from "../pages/Shop/Product/Create";
import ProductEdit from "../pages/Shop/Product/Edit";
import ProductList from "../pages/Shop/Product/List";
import SettlementCreate from "../pages/Settlement/Create";
import SettlementID from "../pages/Settlement/ID";
import SettlementOverview from "../pages/Settlement/Overview";
import SettlementTransactionList from "../pages/Settlement/Transaction";

import UserSocial from "../pages/Profile/Social";
import UserReferral from "../pages/User/Referral";
import RequestWithdraw from "../pages/Sale/Withdraw/requestWithdraw";
import UserUpgrade from "../pages/Settings/Upgrade";
import Messages from "../pages/Messages";

import ProfileDetail from "../pages/Profile/ProfileDetail";
import UserClientsList from "../pages/Profile/Clients";
import UserProfile from "../pages/Profile";
import SettingsBankList from "../pages/Settings/Bank/BankList";
import SettingsBusinessList from "../pages/Settings/Business/BusinessList";
import SettingsPersonalList from "../pages/Settings/Personal/PersonalList";
import SettingsTerminalListAndEdit from "../pages/Settings/Terminal/terminal";
import UserTwoFA from "../pages/Profile/2fa";
import UserPassword from "../pages/Profile/changePassword";
import Loading from "../pages/loading";
import ShopSettings from "@/pages/Settings/ShopSettings/Shop";
import MobileShopSettings from "@/mobile/Settings/ShopSettings";

const {
  home,
  login,
  logout,
  oAuthCallback,
  settlement,
  user,
  mySale,
  myShop,
  connections,
  digitalAccount,
  profile,
  settings,
  register,
} = DashboardRoutes;

const getChildPath = (path: string, depth: number) => {
  const arr = path.split("/");
  arr.splice(0, depth);
  return arr.join("/");
};
export const publicRouter = createBrowserRouter([
  {
    element: <InitRoot />,
    children: [
      // INIT ROUTES
      {
        element: <Login />,
        path: login.url,
        handle: login.meta,
      },
      {
        element: <Logout />,
        path: logout.url,
        handle: logout.meta,
      },
      {
        element: <OAuthCallback />,
        path: oAuthCallback.url,
        handle: oAuthCallback.meta,
      },
      {
        element: <Loading />,
        path: "*",
        index: true,
      },
    ],
  },
]);

export const router = createBrowserRouter([
  {
    element: <InitRoot />,
    children: [
      // INIT ROUTES
      {
        element: <Login />,
        path: login.url,
        handle: login.meta,
      },
      {
        element: <Logout />,
        path: logout.url,
        handle: logout.meta,
      },
      {
        element: <OAuthCallback />,
        path: oAuthCallback.url,
        handle: oAuthCallback.meta,
      },
      {
        element: (
          // <UserCheckPermission
          //   permissionList={[permissionsList.userIsLogin]}
          //   fallBack={<Navigate to={DashboardRoutes.login.url} />}
          // >
          <Main />
          // </UserCheckPermission>
        ),
        children: [
          // TODO there is 2 default pass
          // TODO initApp removed you must do it like admin later

          // home
          {
            path: getChildPath(home.root.url, 1),
            handle: home.root.meta,
            element: <Outlet />,
            children: [
              {
                element: <OverviewPage />,
                path: getChildPath(home.overview.url, 2),
                handle: home.overview.meta,
              },
              {
                element: <Messages />,
                path: getChildPath(home.messages.url, 2),
                handle: home.messages.meta,
              },
              {
                element: <ChangeLog />,
                path: getChildPath(home.changeLog.url, 2),
                handle: home.changeLog.meta,
              },
              {
                element: <Navigate to={home.overview.url} replace />,
                path: "*",
                index: true,
              },
            ],
          },

          // digitalAccount
          {
            path: getChildPath(digitalAccount.root?.url, 1),
            handle: digitalAccount.root?.meta,
            element: <DigitalAccountRoot />,
            children: [
              {
                element: <DigitalAccountHome />,
                path: getChildPath(digitalAccount.home?.url, 2),
                handle: digitalAccount.home?.meta,
              },
              {
                element: <TermsAndConditions />,
                path: getChildPath(digitalAccount.agreement?.url, 2),
                handle: digitalAccount.agreement?.meta,
              },
              {
                element: <YourAccount />,
                path: getChildPath(digitalAccount.yourAccount?.url, 2),
                handle: digitalAccount.yourAccount?.meta,
              },
              {
                element: <SamanCreate />,
                path: getChildPath(digitalAccount.saman.create?.url, 2),
                handle: digitalAccount.saman.create?.meta,
              },
              {
                element: <TermsAndConditions />,
                path: getChildPath(digitalAccount.agreement?.url, 2),
                handle: digitalAccount.agreement?.meta,
              },
              {
                element: <Outlet />,
                path: getChildPath(digitalAccount.jointAccount.root?.url, 2),
                handle: digitalAccount.jointAccount.root?.meta,
                children: [
                  {
                    element: <LoginEzPay />,
                    path: getChildPath(digitalAccount.jointAccount?.khavarmianeh?.url, 3),
                    handle: digitalAccount.jointAccount?.khavarmianeh?.meta,
                  },
                ],
              },
              {
                element: <Outlet />,
                path: getChildPath(digitalAccount.saman.root?.url, 2),
                handle: digitalAccount.saman.root?.meta,
                children: [
                  {
                    element: <AccountConnectionForm />,
                    path: getChildPath(digitalAccount.saman.accountConnection?.url, 3),
                    handle: digitalAccount.saman.accountConnection?.meta,
                  },
                  {
                    element: <GetAccessAccount />,
                    path: getChildPath(digitalAccount.saman?.getAccessAccount?.url, 3),
                    handle: digitalAccount.saman?.getAccessAccount?.meta,
                  },
                  {
                    element: <ShowAllRequestTransferList />,
                    path: getChildPath(digitalAccount.saman?.request?.url, 3),
                    handle: digitalAccount.saman?.request?.meta,
                  },
                  {
                    element: <TurnOver />,
                    path: getChildPath(digitalAccount.saman?.turnOver?.url, 3),
                    handle: digitalAccount.saman?.turnOver?.meta,
                  },
                  {
                    element: <Outlet />,
                    path: getChildPath(digitalAccount.saman.newAccount.root?.url, 3),
                    handle: digitalAccount.saman.newAccount.root?.meta,
                    children: [
                      {
                        element: <OpeningGuid />,
                        path: getChildPath(digitalAccount.saman?.newAccount.offline?.url, 4),
                        handle: digitalAccount.saman?.newAccount.offline?.meta,
                      },
                      {
                        element: <BankFormGuide />,
                        path: getChildPath(digitalAccount.saman?.newAccount.bankFormGuide?.url, 4),
                        handle: digitalAccount.saman?.newAccount.bankFormGuide?.meta,
                      },
                    ],
                  },
                  {
                    element: <Outlet />,
                    path: getChildPath(digitalAccount.saman?.access.root?.url, 3),
                    handle: digitalAccount.saman?.access.root?.meta,
                    children: [
                      {
                        element: <GetInfo />,
                        path: getChildPath(digitalAccount.saman?.access.getInfo?.url, 4),
                        handle: digitalAccount.saman?.access.getInfo?.meta,
                      },
                      {
                        element: <GetAccessHelp />,
                        path: getChildPath(digitalAccount.saman?.access.help?.url, 4),
                        handle: digitalAccount.saman?.access.help?.meta,
                      },
                      {
                        element: <SuccesFul />,
                        path: getChildPath(digitalAccount.saman?.access.success?.url, 4),
                        handle: digitalAccount.saman?.access.success?.meta,
                      },
                      {
                        element: <Fail />,
                        path: getChildPath(digitalAccount.saman?.access.fail?.url, 4),
                        handle: digitalAccount.saman?.access.fail?.meta,
                      },
                    ],
                  },
                ],
              },
              {
                element: <Navigate to={digitalAccount.home?.url} />,
                path: "*",
                index: true,
              },
            ],
          },
          // myShop
          {
            path: getChildPath(myShop.root.url, 1),
            handle: myShop.root.meta,
            element: <MyShopRoot />,
            children: [
              // CUSTOMER
              {
                path: getChildPath(myShop.customer.root.url, 2),
                handle: myShop.customer.root.meta,
                element: <Outlet />,
                children: [
                  {
                    element: <CustomerList />,
                    path: getChildPath(myShop.customer.list.url, 3),
                    handle: myShop.customer.list.meta,
                  },
                  {
                    element: <CustomerCreate />,
                    path: getChildPath(myShop.customer.create.url, 3),
                    handle: myShop.customer.create.meta,
                  },
                  {
                    element: <CustomerCreateBulk />,
                    path: getChildPath(myShop.customer.createBulk.url, 3),
                    handle: myShop.customer.createBulk.meta,
                  },
                  {
                    element: <CustomerEdit />,
                    path: getChildPath(myShop.customer.edit.url, 3),
                    handle: myShop.customer.edit.meta,
                  },
                ],
              },
              // INVOICE
              {
                path: getChildPath(myShop.invoice.root.url, 2),
                handle: myShop.invoice.root.meta,
                element: <Outlet />,
                children: [
                  {
                    element: <InvoiceList />,
                    path: getChildPath(myShop.invoice.list.url, 3),
                    handle: myShop.invoice.list.meta,
                  },
                  {
                    path: getChildPath(myShop.invoice.show.url, 3),
                    handle: myShop.invoice.show.meta,
                    element: (
                      <RequireRole claims={[USER_CLAIMS_LIST.invoiceService]}>
                        <InvoiceCallback />
                      </RequireRole>
                    ),
                  },
                  {
                    element: (
                      <RequireRole claims={[USER_CLAIMS_LIST.invoiceService]}>
                        <InvoiceCorrectInvoice />
                      </RequireRole>
                    ),
                    path: getChildPath(myShop.invoice.correction.url, 3),
                    handle: myShop.invoice.correction.meta,
                  },
                  {
                    element: (
                      <RequireRole claims={[USER_CLAIMS_LIST.invoiceService]}>
                        <InvoiceCreateInvoice />
                      </RequireRole>
                    ),
                    path: getChildPath(myShop.invoice.create.url, 3),
                    handle: myShop.invoice.create.meta,
                  },
                  {
                    element: (
                      <RequireRole claims={[USER_CLAIMS_LIST.invoiceService]}>
                        <InvoiceEditInvoice />
                      </RequireRole>
                    ),
                    path: getChildPath(myShop.invoice.edit.url, 3),
                    handle: myShop.invoice.edit.meta,
                  },
                ],
              },

              // PRODUCT
              {
                path: getChildPath(myShop.product.root.url, 2),
                handle: myShop.product.root.meta,
                element: <Outlet />,
                children: [
                  {
                    element: <ProductList />,
                    path: getChildPath(myShop.product.list.url, 3),
                    handle: myShop.product.list.meta,
                  },
                  {
                    element: <ProductCreate />,
                    path: getChildPath(myShop.product.create.url, 3),
                    handle: myShop.product.create.meta,
                  },
                  {
                    element: <ProductEdit />,
                    path: getChildPath(myShop.product.edit.url, 3),
                    handle: myShop.product.edit.meta,
                  },
                  {
                    element: <ProductCreateBulk />,
                    path: getChildPath(myShop.product.createBulk.url, 3),
                    handle: myShop.product.createBulk.meta,
                  },
                ],
              },

              // Coupon
              {
                path: getChildPath(myShop.coupon.root.url, 2),
                handle: myShop.coupon.root.meta,
                element: <Outlet />,
                children: [
                  {
                    element: <ProductCouponList />,
                    path: getChildPath(myShop.coupon.list.url, 3),
                    handle: myShop.coupon.list.meta,
                  },
                  {
                    element: <ProductCreateCoupon />,
                    path: getChildPath(myShop.coupon.create.url, 3),
                    handle: myShop.coupon.create.meta,
                  },
                  {
                    element: <ProductEditCoupon />,
                    path: getChildPath(myShop.coupon.edit.url, 3),
                    handle: myShop.coupon.edit.meta,
                  },
                ],
              },

              // BNPL
              {
                path: getChildPath(myShop.bnpl.root.url, 2),
                handle: myShop.bnpl.root.meta,
                element: <Outlet />,
                children: [
                  {
                    path: getChildPath(DashboardRoutes.myShop.bnpl.activation.root.url, 3),
                    handle: myShop.bnpl.manage.root.meta,
                    element: <BnplActivationPage />,
                  },
                  {
                    path: getChildPath(DashboardRoutes.myShop.bnpl.manage.root.url, 3),
                    handle: myShop.bnpl.manage.root.meta,
                    element: (
                      <BnplManageCreditLayout>
                        <BnplManageCreditPage />
                      </BnplManageCreditLayout>
                    ),
                  },

                  {
                    path: getChildPath(myShop.bnpl.plans.addPlan.root.url, 3),
                    handle: myShop.bnpl.plans.addPlan.root.meta,
                    element: (
                      <BnplPlansLayout>
                        <BnplManagePlanPage />
                      </BnplPlansLayout>
                    ),
                  },
                  {
                    path: getChildPath(myShop.bnpl.plans.root.url, 3),
                    handle: myShop.bnpl.plans.root.meta,
                    element: (
                      <BnplPlansLayout>
                        <BnplManagePlanList />
                      </BnplPlansLayout>
                    ),
                  },
                  {
                    path: getChildPath(myShop.bnpl.list.root.url, 3),
                    handle: myShop.bnpl.list.root.meta,
                    element: <BnplListPage />,
                  },
                  {
                    path: getChildPath(myShop.bnpl.financialCalender.root.url, 3),
                    handle: myShop,
                    element: <BnplFinancialCalender />,
                  },
                  {
                    element: <Navigate to={DashboardRoutes.myShop.bnpl.manage.root.url} />,
                    path: "*",
                    index: true,
                  },
                ],
              },
              {
                element: <Navigate to={myShop.product.list.url} />,
                path: "*",
                index: true,
                handle: myShop.product.list.meta,
              },
            ],
          },

          // mySale
          {
            path: getChildPath(mySale.root.url, 1),
            handle: mySale.root.meta,
            element: <MySaleRoot />,
            children: [
              {
                element: <ReportSale />,
                path: getChildPath(mySale.report.url, 2),
                handle: mySale.report.meta,
              },
              {
                element: <BalanceAndWithdraw />,
                path: getChildPath(mySale.balanceAndWithdraw.url, 2),
                handle: mySale.balanceAndWithdraw.meta,
              },
              {
                element: <RequestWithdraw />,
                path: getChildPath(mySale.requestWithdraw.url, 2),
                handle: mySale.requestWithdraw.meta,
              },
              {
                element: <Navigate to={mySale.report.url} />,
                path: "*",
                index: true,
              },
            ],
          },

          //  Connection
          {
            element: <ConnectionsRoot />,
            path: getChildPath(connections.root.url, 1),
            handle: connections.root.meta,
            children: [
              // Developers
              {
                element: <Developers />,
                path: getChildPath(connections.developers.root.url, 2),
                handle: connections.developers.root.meta,
                children: [
                  {
                    element: <TokenList />,
                    path: getChildPath(connections.developers.tokensList.url, 3),
                    handle: connections.developers.tokensList.meta,
                  },
                ],
              },
              // Oauth
              {
                element: <IpgOauth />,
                path: getChildPath(connections.oauth.root.url, 2),
                handle: connections.oauth.root.meta,
              },
              // Plugins
              {
                element: <ConnectionsPluginsPage />,
                path: getChildPath(connections.plugins.root.url, 2),
                handle: connections.plugins.root.meta,
                children: [
                  {
                    element: <ConnectionsPluginsDetailsPage />,
                    path: getChildPath(connections.plugins.details.url, 3),
                    handle: connections.plugins.details.meta,
                  },
                ],
              },

              {
                element: <Navigate to={connections.plugins.root.url} />,
                path: "*",
                index: true,
              },
            ],
          },

          // Profile
          {
            element: <DetectMobileView mobile={<MobileProfileWrapper />} desktop={<UserProfile />} />,
            path: getChildPath(profile.root.url, 1),
            handle: profile.root.meta,
            children: [
              // Mobile Menu
              {
                element: <MobileProfileMenu />,
                path: getChildPath(profile.mRoot.url, 2),
                handle: profile.mRoot.meta,
              },
              {
                element: <DetectMobileView mobile={<MobileProfileDetails />} desktop={<ProfileDetail />} />,
                path: getChildPath(profile.detail.url, 2),
                handle: profile.detail.meta,
              },
              {
                element: <DetectMobileView mobile={<MobileProfilePassword />} desktop={<UserPassword />} />,
                path: getChildPath(profile.password.url, 2),
                handle: profile.password.meta,
              },
              {
                element: <UserTwoFA />,
                path: getChildPath(profile["2fa"].url, 2),
                handle: profile["2fa"].meta,
              },
              // MobileProfile2Fa Login
              {
                element: <Outlet />,
                path: getChildPath(profile.m2fa.root.url, 2),
                handle: profile.m2fa.root.meta,
                children: [
                  {
                    element: <MobileProfile2Fa />,
                    path: getChildPath(profile.m2fa.menu.url, 3),
                    handle: profile.m2fa.menu.meta,
                  },
                  {
                    element: <MobileEnableLogin2Fa />,
                    path: getChildPath(profile.m2fa.loginEnable.url, 3),
                    handle: profile.m2fa.loginEnable.meta,
                  },
                  {
                    element: <MobileDisableLogin2Fa />,
                    path: getChildPath(profile.m2fa.loginDisable.url, 3),
                    handle: profile.m2fa.loginDisable.meta,
                  },
                  {
                    path: "*",
                    element: <Navigate to={profile.m2fa.menu.url} />,
                    index: true,
                  },
                ],
              },
              // MobileProfile2Fa Cash
              {
                element: <DetectMobileView mobile={<MobileProfileMessaging />} desktop={<UserMessaging />} />,
                path: getChildPath(profile.messaging.url, 2),
                handle: profile.messaging.meta,
              },
              // تنظیمات نمایش
              //
              // {
              //   element: <DetectMobileView mobile={<MobileProfileDisplay />} desktop={<DisplaySettings />} />,
              //   path: getChildPath(profile.display.url, 2),
              // handle: profile.display.meta,
              // },
              //
              {
                element: <DetectMobileView mobile={<MobileProfileClient />} desktop={<UserClientsList />} />,
                path: getChildPath(profile.client.url, 2),
                handle: profile.client.meta,
              },
              {
                element: <DetectMobileView mobile={<MobileProfileSocial />} desktop={<UserSocial />} />,
                path: getChildPath(profile.social.url, 2),
                handle: profile.social.meta,
              },
              {
                element: (
                  <DetectMobileView
                    mobile={<Navigate to={profile.mRoot.url} />}
                    desktop={<Navigate to={profile.detail.url} replace />}
                  />
                ),
                path: "*",
                index: true,
              },
            ],
          },

          // Settings
          {
            element: <DetectMobileView mobile={<MobileSettingsWrapper />} desktop={<SettingsList />} />,
            path: getChildPath(settings.root.url, 1),
            handle: settings.root.meta,
            children: [
              {
                element: <MobileSettingsMenu />,
                path: getChildPath(settings.mRoot.url, 2),
                handle: settings.mRoot.meta,
              },

              // Personal
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsPersonalList]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <DetectMobileView desktop={<SettingsPersonalList />} mobile={<MobileSettingsPersonalList />} />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.personal.root.url, 2),
                handle: settings.personal.root.meta,
              },
              // Personal --- Desktop Edit
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsPersonalEdit]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <UserPersonal />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.personal.edit.url, 2),
                handle: settings.personal.edit.meta,
              },
              // Personal --- Mobile Edit
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsPersonalEditMobile]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <Outlet />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.mEditPersonal.root.url, 2),
                handle: settings.mEditPersonal.root.meta,
                children: [
                  {
                    element: <MobileEditName />,
                    path: getChildPath(settings.mEditPersonal.name.url, 3),
                    handle: settings.mEditPersonal.name.meta,
                  },
                  {
                    element: <MobileEditLastName />,
                    path: getChildPath(settings.mEditPersonal.lastName.url, 3),
                    handle: settings.mEditPersonal.lastName.meta,
                  },
                  {
                    element: <MobileEditFatherName />,
                    path: getChildPath(settings.mEditPersonal.fatherName.url, 3),
                    handle: settings.mEditPersonal.fatherName.meta,
                  },
                  {
                    element: <MobileEditPhoneNumber />,
                    path: getChildPath(settings.mEditPersonal.phoneNumber.url, 3),
                    handle: settings.mEditPersonal.phoneNumber.meta,
                  },
                  {
                    element: <MobileEditBirthDate />,
                    path: getChildPath(settings.mEditPersonal.birthDate.url, 3),
                    handle: settings.mEditPersonal.birthDate.meta,
                  },
                  {
                    element: <MobileEditBirthCertificateNumber />,
                    path: getChildPath(settings.mEditPersonal.birthCertificateNumber.url, 3),
                    handle: settings.mEditPersonal.birthCertificateNumber.meta,
                  },
                  {
                    element: <MobileEditNationalCode />,
                    path: getChildPath(settings.mEditPersonal.nationalCode.url, 3),
                    handle: settings.mEditPersonal.nationalCode.meta,
                  },
                  {
                    element: <MobileEditEmail />,
                    path: getChildPath(settings.mEditPersonal.email.url, 3),
                    handle: settings.mEditPersonal.email.meta,
                  },
                  {
                    element: <ProfilePhoto />,
                    path: getChildPath(settings.mEditPersonal.documents.url, 3),
                    handle: settings.mEditPersonal.documents.meta,
                  },
                ],
              },

              // Bank
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsBankEdit]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <UserBank />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.bank.root.url, 2),
                handle: settings.bank.root.meta,
              },
              // Bank --- Desktop Edit
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsBankList]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <DetectMobileView mobile={<MobileBankList />} desktop={<SettingsBankList />} />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.bank.edit.url, 2),
                handle: settings.bank.edit.meta,
              },
              // Bank --- Mobile Edit
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsBankEditMobile]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <MobileEditShaba />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.mEditBank.shaba.url, 2),
                handle: settings.mEditBank.shaba.meta,
              },

              // Business
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsBusinessList]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <DetectMobileView mobile={<MobileBusinessList />} desktop={<SettingsBusinessList />} />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.business.root.url, 2),
                handle: settings.business.root.meta,
              },
              // Business --- Desktop Edit
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsBusinessEdit]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <UserBusiness />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.business.edit.url, 2),
                handle: settings.business.edit.meta,
              },
              // Business --- Mobile Edit
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settingsBusinessEditMobile]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <Outlet />
                  </UserCheckPermission>
                ),
                path: getChildPath(settings.mEditBusiness.root.url, 2),
                handle: settings.mEditBusiness.root.meta,
                children: [
                  {
                    element: <BusinessName />,
                    path: getChildPath(settings.mEditBusiness.name.url, 3),
                    handle: settings.mEditBusiness.name.meta,
                  },
                  {
                    element: <BusinessDescription />,
                    path: getChildPath(settings.mEditBusiness.description.url, 3),
                    handle: settings.mEditBusiness.description.meta,
                  },
                  {
                    element: <BusinessState />,
                    path: getChildPath(settings.mEditBusiness.state.url, 3),
                    handle: settings.mEditBusiness.state.meta,
                  },
                  {
                    element: <BusinessCity />,
                    path: getChildPath(settings.mEditBusiness.city.url, 3),
                    handle: settings.mEditBusiness.city.meta,
                  },
                  {
                    element: <BusinessAddress />,
                    path: getChildPath(settings.mEditBusiness.address.url, 3),
                    handle: settings.mEditBusiness.address.meta,
                  },
                  {
                    element: <BusinessPhone />,
                    path: getChildPath(settings.mEditBusiness.phone.url, 3),
                    handle: settings.mEditBusiness.phone.meta,
                  },
                  {
                    element: <BusinessPostalCode />,
                    path: getChildPath(settings.mEditBusiness.postalCode.url, 3),
                    handle: settings.mEditBusiness.postalCode.meta,
                  },
                  {
                    element: <BusinessWebsite />,
                    path: getChildPath(settings.mEditBusiness.site.url, 3),
                    handle: settings.mEditBusiness.site.meta,
                  },
                  {
                    element: <BusinessTaxcode />,
                    path: getChildPath(settings.mEditBusiness.taxCode.url, 3),
                    handle: settings.mEditBusiness.taxCode.meta,
                  },
                  {
                    element: <OfficialSubmited />,
                    path: getChildPath(settings.mEditBusiness.businessRegistrationStatus.url, 3),
                    handle: settings.mEditBusiness.businessRegistrationStatus.meta,
                  },
                  {
                    element: <OfficialBusinessName />,
                    path: getChildPath(settings.mEditBusiness.officialBusinessName.url, 3),
                    handle: settings.mEditBusiness.officialBusinessName.meta,
                  },
                  {
                    element: <OfficialBusinessRegistrationDate />,
                    path: getChildPath(settings.mEditBusiness.officialBusinessRegistrationDate.url, 3),
                    handle: settings.mEditBusiness.officialBusinessRegistrationDate.meta,
                  },
                  {
                    element: <OfficialBusinessSabtNumber />,
                    path: getChildPath(settings.mEditBusiness.officialBusinessSabtNumber.url, 3),
                    handle: settings.mEditBusiness.officialBusinessSabtNumber.meta,
                  },
                  {
                    element: <OfficialBusinessNationalCode />,
                    path: getChildPath(settings.mEditBusiness.officialBusinessbNationalCode.url, 3),
                    handle: settings.mEditBusiness.officialBusinessbNationalCode.meta,
                  },
                  {
                    element: <MobileEditOfficialBusinessEconomicCode />,
                    path: getChildPath(settings.mEditBusiness.officialBusinessEconomicCode.url, 3),
                    handle: settings.mEditBusiness.officialBusinessEconomicCode.meta,
                  },
                  {
                    element: <MobileEditOfficialBusinessDocument />,
                    path: getChildPath(settings.mEditBusiness.officialBusinessDocument.url, 3),
                    handle: settings.mEditBusiness.officialBusinessDocument.meta,
                  },
                ],
              },
              // Business --- Mobile Edit
              // Terminal
              {
                element: <DetectMobileView mobile={<MobileTerminalList />} desktop={<SettingsTerminalListAndEdit />} />,
                path: getChildPath(settings.terminal.url, 2),
                handle: settings.terminal.meta,
              },
              {
                element: <DetectMobileView mobile={<MobileShopSettings />} desktop={<ShopSettings />} />,
                path: getChildPath(settings.shop.url, 2),
                handle: settings.shop.meta,
              },
              {
                element: (
                  <DetectMobileView
                    mobile={<Navigate to={settings.mRoot.url} replace />}
                    desktop={<Navigate to={settings.personal.root.url} replace />}
                  />
                ),
                path: "*",
                index: true,
              },
            ],
          },

          // User
          {
            path: getChildPath(user.root.url, 1),
            handle: user.root.meta,
            element: <Outlet />,
            children: [
              {
                element: <UserReferral />,
                path: getChildPath(user.referral.url, 2),
                handle: user.referral.meta,
              },
              {
                element: <UserUpgrade />,
                path: getChildPath(user.upgrade.url, 2),
                handle: user.upgrade.meta,
              },
              {
                path: "*",
                element: <Navigate to={user.referral.url} />,
                index: true,
              },
            ],
          },

          // Register REQUEST_PAYMENT_GATEWAY
          {
            element: <Outlet />,
            path: getChildPath(register.root.url, 1),
            handle: register.root.meta,
            children: [
              // common Routes URL Between Mobile and Desktop
              {
                element: <DetectMobileView mobile={<MobileSettingsPersonalList />} desktop={<UserPersonal />} />,
                path: getChildPath(register.personal.url, 2),
                handle: register.personal.meta,
              },
              {
                element: <DetectMobileView mobile={<MobileBusinessList />} desktop={<UserBusiness />} />,
                path: getChildPath(register.business.url, 2),
                handle: register.business.meta,
              },
              {
                element: <DetectMobileView mobile={<MobileEditShaba />} desktop={<UserBank />} />,
                path: getChildPath(register.bank.url, 2),
                handle: register.bank.meta,
              },
              {
                element: <Navigate to={register.personal.url} replace />,
                path: "*",
                index: true,
              },

              // Register Mobile Personal --- Mobile Only
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.registerPersonal]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <Outlet />
                  </UserCheckPermission>
                ),
                path: getChildPath(register.mEditPersonal.root.url, 2),
                handle: register.mEditPersonal.root.meta,
                children: [
                  {
                    element: <MobileEditName />,
                    path: getChildPath(register.mEditPersonal.name.url, 3),
                    handle: register.mEditPersonal.name.meta,
                  },
                  {
                    element: <MobileEditLastName />,
                    path: getChildPath(register.mEditPersonal.lastName.url, 3),
                    handle: register.mEditPersonal.lastName.meta,
                  },
                  {
                    element: <MobileEditFatherName />,
                    path: getChildPath(register.mEditPersonal.fatherName.url, 3),
                    handle: register.mEditPersonal.fatherName.meta,
                  },
                  {
                    element: <MobileEditPhoneNumber />,
                    path: getChildPath(register.mEditPersonal.phoneNumber.url, 3),
                    handle: register.mEditPersonal.phoneNumber.meta,
                  },
                  {
                    element: <MobileEditBirthDate />,
                    path: getChildPath(register.mEditPersonal.birthDate.url, 3),
                    handle: register.mEditPersonal.birthDate.meta,
                  },
                  {
                    element: <MobileEditBirthCertificateNumber />,
                    path: getChildPath(register.mEditPersonal.birthCertificateNumber.url, 3),
                    handle: register.mEditPersonal.birthCertificateNumber.meta,
                  },
                  {
                    element: <MobileEditNationalCode />,
                    path: getChildPath(register.mEditPersonal.nationalCode.url, 3),
                    handle: register.mEditPersonal.nationalCode.meta,
                  },
                  {
                    element: <MobileEditEmail />,
                    path: getChildPath(register.mEditPersonal.email.url, 3),
                    handle: register.mEditPersonal.email.meta,
                  },
                  {
                    element: <ProfilePhoto />,
                    path: getChildPath(register.mEditPersonal.documents.url, 3),
                    handle: register.mEditPersonal.documents.meta,
                  },
                  {
                    element: <Navigate to={register.personal.url} replace />,
                    path: "*",
                    index: true,
                  },
                ],
              },

              // Register Mobile Business --- Mobile Only
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.registerBusinessCreate]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <Outlet />
                  </UserCheckPermission>
                ),
                path: getChildPath(register.mEditBusiness.root.url, 2),
                handle: register.mEditBusiness.root.meta,
                children: [
                  {
                    element: <BusinessName />,
                    path: getChildPath(register.mEditBusiness.name.url, 3),
                    handle: register.mEditBusiness.name.meta,
                  },
                  {
                    element: <BusinessDescription />,
                    path: getChildPath(register.mEditBusiness.description.url, 3),
                    handle: register.mEditBusiness.description.meta,
                  },
                  {
                    element: <BusinessState />,
                    path: getChildPath(register.mEditBusiness.state.url, 3),
                    handle: register.mEditBusiness.state.meta,
                  },
                  {
                    element: <BusinessCity />,
                    path: getChildPath(register.mEditBusiness.city.url, 3),
                    handle: register.mEditBusiness.city.meta,
                  },
                  {
                    element: <BusinessAddress />,
                    path: getChildPath(register.mEditBusiness.address.url, 3),
                    handle: register.mEditBusiness.address.meta,
                  },
                  {
                    element: <BusinessPhone />,
                    path: getChildPath(register.mEditBusiness.phone.url, 3),
                    handle: register.mEditBusiness.phone.meta,
                  },
                  {
                    element: <BusinessPostalCode />,
                    path: getChildPath(register.mEditBusiness.postalCode.url, 3),
                    handle: register.mEditBusiness.postalCode.meta,
                  },
                  {
                    element: <BusinessWebsite />,
                    path: getChildPath(register.mEditBusiness.site.url, 3),
                    handle: register.mEditBusiness.site.meta,
                  },
                  {
                    element: <BusinessTaxcode />,
                    path: getChildPath(register.mEditBusiness.taxCode.url, 3),
                    handle: register.mEditBusiness.taxCode.meta,
                  },
                  {
                    element: <OfficialSubmited />,
                    path: getChildPath(register.mEditBusiness.businessRegistrationStatus.url, 3),
                    handle: register.mEditBusiness.businessRegistrationStatus.meta,
                  },
                  {
                    element: <OfficialBusinessName />,
                    path: getChildPath(register.mEditBusiness.officialBusinessName.url, 3),
                    handle: register.mEditBusiness.officialBusinessName.meta,
                  },
                  {
                    element: <OfficialBusinessRegistrationDate />,
                    path: getChildPath(register.mEditBusiness.officialBusinessRegistrationDate.url, 3),
                    handle: register.mEditBusiness.officialBusinessRegistrationDate.meta,
                  },
                  {
                    element: <OfficialBusinessSabtNumber />,
                    path: getChildPath(register.mEditBusiness.officialBusinessSabtNumber.url, 3),
                    handle: register.mEditBusiness.officialBusinessSabtNumber.meta,
                  },
                  {
                    element: <OfficialBusinessNationalCode />,
                    path: getChildPath(register.mEditBusiness.officialBusinessbNationalCode.url, 3),
                    handle: register.mEditBusiness.officialBusinessbNationalCode.meta,
                  },
                  {
                    element: <MobileEditOfficialBusinessEconomicCode />,
                    path: getChildPath(register.mEditBusiness.officialBusinessEconomicCode.url, 3),
                    handle: register.mEditBusiness.officialBusinessEconomicCode.meta,
                  },
                  {
                    element: <MobileEditOfficialBusinessDocument />,
                    path: getChildPath(register.mEditBusiness.officialBusinessDocument.url, 3),
                    handle: register.mEditBusiness.officialBusinessDocument.meta,
                  },
                  {
                    element: <Navigate to={register.business.url} replace />,
                    path: "*",
                    index: true,
                  },
                ],
              },
            ],
          },

          // Settlement
          {
            // TODO we have exactly like this
            path: getChildPath(settlement.root.url, 1),
            handle: settlement.root.meta,
            element: <SettlementRoot />,
            children: [
              // در یک نگاه
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementOverview]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <SettlementOverview />
                  </UserCheckPermission>
                ),
                path: getChildPath(DashboardRoutes.settlement.overview.url, 2),
                handle: DashboardRoutes.settlement.overview.meta,
              },
              // ایجاد تسویه
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementCreate]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <SettlementCreate />
                  </UserCheckPermission>
                ),
                path: getChildPath(settlement.create.url, 2),
                handle: settlement.create.meta,
              },
              // گزارش تسویه ها
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementList]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <SettlementList />
                  </UserCheckPermission>
                ),
                path: getChildPath(settlement.report.list.url, 2),
                handle: settlement.report.list.meta,
              },
              // گردش حساب
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementTransactionList]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <SettlementTransactionList />
                  </UserCheckPermission>
                ),
                path: getChildPath(settlement.transaction.url, 2),
                handle: settlement.transaction.meta,
              },
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementRecordList]}
                    fallBack={<Navigate to={DashboardRoutes.home.overview.url} />}
                  >
                    <SettlementRecordList />
                  </UserCheckPermission>
                ),
                path: getChildPath(settlement.report.detail.url, 2),
                handle: settlement.report.detail.meta,
              },
              // شناسه های واریز
              // TODO move into RequirePermission HOC later
              // IDENTITY_ROUTES **PRIVATE route**
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementID]}
                    fallBack={<Navigate to={DashboardRoutes.settlement.overview.url} />}
                  >
                    <SettlementID />
                  </UserCheckPermission>
                ),
                path: getChildPath(settlement.id.url, 2),
                handle: settlement.id.meta,
              },
              {
                element: (
                  <UserCheckPermission
                    permissionList={[permissionsList.settlementIDCreate]}
                    fallBack={<Navigate to={DashboardRoutes.settlement.overview.url} />}
                  >
                    <SettlementIDCreate />
                  </UserCheckPermission>
                ),
                path: getChildPath(settlement.createId.url, 2),
                handle: settlement.createId.meta,
              },
              {
                element: <Navigate to={DashboardRoutes.settlement.overview.url} replace />,
                path: "*",
                index: true,
              },
            ],
          },

          // Refund
          ...refundRoutes,

          {
            element: <Navigate to={home.overview.url} replace />,
            path: "*",
            index: true,
          },
        ],
      },
    ],
  },
]);
